import React, { useEffect, useState } from 'react';
import { Link, useLoaderData } from 'react-router-dom';
import './company-admin-project-modules.css';
import { useDispatch } from 'react-redux';
import { AxiosResponse } from 'axios';
import { GetProjectSuccessResponse } from '../../../../../../types/api/project/get-project-success-response';
import { CompanyAdminWorkInstructions } from '../work-instructions/index/company-admin-work-instructions';
import { CompanyAdminModelIndex } from '../models/index/company-admin-model-index';
import { setSelectedMenuItemKeys } from '../../../../../../../../redux/reducer/antd-layout-info.reducer';
import { getImageUrl } from '../../../../../../../../utils/image-helper/get-image-url';
import { CMSButton } from '../../../../../../../../components/cms/button/cms-button.';

export const CompanyAdminProjectModules = () => {
    const loaderData: any = useLoaderData();
    const dispatch = useDispatch();
    const [activeModuleMenu, setActiveModuleMenu] = useState<'workInstructionModule' | 'modulSpaceModule' | null>(null);
    const [prevProjectResponse, setPrevProjectResponse] = useState();

    if (prevProjectResponse !== loaderData.getProjectResponse) {
        setPrevProjectResponse(loaderData.getProjectResponse);
        if (loaderData.getProjectResponse?.status === 200) {
            const res: AxiosResponse<GetProjectSuccessResponse> = loaderData.getProjectResponse;

            if (res.data.project.workInstructionModule === true) setActiveModuleMenu('workInstructionModule');
            else if (res.data.project.modelSpaceModule === true) setActiveModuleMenu('modulSpaceModule');
        }
    }

    useEffect(() => {
        dispatch(setSelectedMenuItemKeys(['company-admin-projects']));
    }, [dispatch]);

    return (
        <>
            <div className="company-admin-project-modules-header d-flex gap-4 align-items-end mb-3">
                <div className='project-name flex-grow-1'>
                    <Link to={'/cms/company-admin/projects'}>
                        <img src={getImageUrl('arrow-left.png')} alt="arrow-left" />
                    </Link>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    {loaderData?.getProjectResponse?.data?.project?.name}
                </div>
                {
                    loaderData?.getProjectResponse?.data?.project.workInstructionModule === true && (
                        <CMSButton
                            text='Munkautasítás'
                            type={activeModuleMenu === 'workInstructionModule' ? 'blue' : 'white'}
                            onClick={() => setActiveModuleMenu('workInstructionModule')}
                        />
                    )
                }
                {
                    loaderData?.getProjectResponse?.data?.project.modelSpaceModule === true && (
                        <CMSButton
                            text='Modelltér'
                            type={activeModuleMenu === 'modulSpaceModule' ? 'blue' : 'white'}
                            onClick={() => setActiveModuleMenu('modulSpaceModule')}
                        />
                    )
                }
            </div>
            <div>
                {activeModuleMenu === 'workInstructionModule' && <CompanyAdminWorkInstructions project={loaderData?.getProjectResponse?.data?.project} />}
                {activeModuleMenu === 'modulSpaceModule' && <CompanyAdminModelIndex project={loaderData?.getProjectResponse?.data?.project} />}
                {activeModuleMenu === null && (
                        <div className="text-center">
                            Nincs modul hozzárendelve a projekthez.
                        </div>
                    )
                }
            </div>
        </>
    );
};